import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { footerStyles } from './styles';

const Footer = (props) => {
    const styles = footerStyles
    return (
        <div>
            <h2>Hey, I'm a Footer.</h2>
        </div>
    )
};

export default Footer;


// WEBPACK FOOTER //
// ./src/js/components/Footer/Footer.jsx